<template>
  <div class="sl-search-form color-bg--white">
    <el-form :model="form" :label-width="`${labelWidth}px`">
      <el-row :gutter="15">
        <el-col v-if="$slots.before" :span="24">
          <slot name="before"></slot>
        </el-col>
        <!-- 支持外部定义栅格布局的场景：dialog调用（width变小，栅格需要变大） -->
        <el-col v-for="(item,index) in items"
          class="form-item-col"
          :xs="$attrs.xs || 24"
          :sm="$attrs.sm || 24"
          :md="$attrs.md || 24"
          :lg="$attrs.lg || 8"
          :xl="$attrs.xl || 6"
          :key="'item_'+index"
        >
          <el-input v-if="item.type === 'prepend-input'"
            :placeholder="item.label"
            v-model.trim="form[item.name]"
            @input="formChange"
            clearable
          >
            <el-select
              v-if="item.prepend && item.prepend.type === 'select'"
              v-model="form[`${item.name}_prepend`]"
              slot="prepend"
              placeholder="请选择"
              style="width:100px"
            >
              <el-option
                v-for="(item,index) in item.prepend.options"
                :key="'prepend_opt_'+index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-input>
          <el-form-item v-else-if="item.type === 'input'"
            :label="item.hideLabel? '':item.label"
            :prop="item.name"
          >
            <el-input
              :placeholder="item.label"
              v-model.trim="form[item.name]"
              @input="formChange"
              clearable
            ></el-input>
          </el-form-item>
          <template v-else-if="item.type === 'single-select'">
            <el-form-item
              :label="item.hideLabel? '':item.label"
              :prop="item.name"
              :class="{'block':item.data.isBlock}"
            >
              <SlSingleSelect
                :label="item.hideLabel?item.label:'请选择'"
                v-model="form[item.name]"
                :remoteUrl="item.data.remoteUrl"
                :reqParams="item.data.params"
                :filterFn="item.data.filter"
                :options="options[item.name]"
              ></SlSingleSelect>
            </el-form-item>
          </template>
          <!-- 树型下拉 -->
          <template v-else-if="item.type === 'tree-select'">
            <el-form-item
              :label="item.hideLabel? '':item.label"
              :prop="item.name"
              :class="{'block':item.data.isBlock}"
            >
              <SlTreeSelect
                v-model="form[item.name]"
                :options="options[item.name]"
                :label="item.hideLabel?item.label:'请选择'"
              ></SlTreeSelect>
            </el-form-item>
          </template>
          <template v-else-if="item.type === 'date'">
            <el-form-item
              :label="item.hideLabel? '':item.label"
              :prop="item.name"
              :class="{'block':item.data.isBlock}"
            >
              <el-date-picker
                v-model="form[item.name]"
                :type="item.data.datetype"
                placeholder="选择日期"
                unlink-panels
                :picker-options="item.data.pickerOptions ? item.data.pickerOptions : getDatePickerOptions(item.data.datetype)"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00','23:59:59']"
                :format="item.data.format?item.data.format:'yyyy-MM-dd'"
                :value-format="item.data.valueFormat?item.data.valueFormat:'yyyy-MM-dd HH:mm:ss'"
                :clearable="item.data.clearable"
              ></el-date-picker>
            </el-form-item>
          </template>
          <template v-else-if="item.type === 'batch-input'">
            <el-form-item :label="item.hideLabel? '':item.label" :prop="item.name">
              <SlBatchInput
                v-model.trim="form[item.name]"
                :maxLen="item.data && item.data.maxLen?item.data.maxLen:200"
                :label="item.label"
              ></SlBatchInput>
            </el-form-item>
          </template>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="6">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="search"
            plain
          >搜索</el-button>
          <el-button icon="el-icon-refresh-right" :loading="loading" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getDatePickerOptions } from '@shared/util/dateFormat'

export default {
  name: 'SlSearchForm',
  model: {
    prop: 'modelVal',
    event: 'valChange'
  },
  props: {
    modelVal: {
      type: Object,
      required: true,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    labelWidth: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: {},
      resetForm: {},
      form: {},
      getDatePickerOptions: getDatePickerOptions
    }
  },
  computed: {

  },
  methods: {
    formChange () {
      this.$emit('valChange', this.form)
    },
    search () {
      this.$emit('search')
    },
    reset () {
      this.resetFormData()
      this.$emit('reset')
    },
    resetFormData () {
      this.form = JSON.parse(JSON.stringify(this.resetForm))
      this.$emit('valChange', this.form)
    }
  },
  created () {
    this.form = Object.assign({}, JSON.parse(JSON.stringify(this.modelVal)))
    this.items.forEach(item => {
      /// 判断入参是否有设置默认值。
      /// 若有就取传入的默认值。
      /// 若没有，则根据是否是多选设置默认值。
      const defaultValue = this.form[item.name] ? this.form[item.name] : item.hasOwnProperty('default') ? item.default : item.isMultivalued ? [] : ''
      this.$set(this.form, item.name, defaultValue)
      if (item['prepend']) {
        this.$set(this.form, `${item.name}_prepend`, item['prepend'].value)
      }
      if (item.data && item.data.options) {
        this.$set(this.options, item.name, item.data.options)
      }
    })
    // 保存初始表单值
    Object.keys(this.form).forEach(key => {
      this.resetForm[key] = this.form[key]
    })
  },
  mounted () {
    this.formChange()
  }

}
</script>
<style lang="scss" scoped>
.sl-search-form {
  padding: 2rem 2.4rem 2rem;
  margin-bottom: 2rem;
  & /deep/ {
    .form-item-col {
      height: 50px;
    }

    .block {
      .el-select {
        display: block;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
}
</style>
